export const formatArrayToMultipleWordsSeparatedByComma = (
  words: string[],
): string => {
  const phrase = words.join(', ')

  const lastIndexOfComma = phrase.lastIndexOf(',')

  if (lastIndexOfComma === -1) return phrase

  return `${phrase.substring(0, lastIndexOfComma)} e ${phrase.substring(
    lastIndexOfComma + 1,
  )}`
}

export function capitalizeFirstLetter(string) {
  if (!string) return ''
  return string
    .toLowerCase()
    .replace(/(^\w|\s\w)/g, match => match.toUpperCase())
}

export function pluralizeWord(
  singularWord: string,
  pluralWord: string,
  lengthToCheck: number,
) {
  return lengthToCheck > 1 ? pluralWord : singularWord
}

export const getFirstName = (name: string): string => {
  if (!name) return ''
  const firstName = capitalizeFirstLetter(name?.trim()?.split(' ')?.[0])
  return firstName
}

export function removeNonDigits(input: string): string {
  if (!input) return ''
  return input?.replace(/[^\d]/g, '')
}

export const sanitizeAlphaNumeric = (value: string) => {
  if (!value) return ''
  return value?.replace(/[^a-zA-Z0-9]/g, '')
}
